import { useNotification } from '@revenuewell/logic-notification';
import { LinkButton } from 'apps/wrapper/src/components/shared/buttons';
import { PatientActions } from 'apps/wrapper/src/components/shared/contact/patient-actions/patient-actions';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import moment from 'moment';
import { useCallback } from 'react';
import { usePatientProfile } from '../../../../../../hooks/use-patient-profile/use-patient-profile';
import { formatPhoneNumber } from '../../../../../../utils/formatter';
import { DotSeparator } from '../../../../../shared/dot-separator/dot-separator.styles';
import { PatientDetails, PatientInfo, PatientInfoWrapper, PatientName, RpWrapper } from './contact-info.styles';

export const ContactInfo = () => {
  const { contactDetails, locationId } = usePatientProfile();
  const { publish } = useEventBus();
  const { showWarning } = useNotification();

  const getPhoneNumber = (contactDetails: any) => {
    if (contactDetails.cellPhone) return formatPhoneNumber(contactDetails.cellPhone);
    else if (contactDetails.homePhone) return formatPhoneNumber(contactDetails.homePhone);
    else if (contactDetails.workPhone) return formatPhoneNumber(contactDetails.workPhone);
    return '';
  };

  const getContactName = useCallback(() => {
    const name = `${contactDetails.firstName} ${contactDetails.lastName}`;
    // if (contactsByPhone?.length > 1) return name += ' + Others';
    return name;
  }, [contactDetails /*, contactsByPhone*/]);

  const getPatientDetails = useCallback(() => {
    const rpComponent = contactDetails.isResponsibleParty ? <RpWrapper>RP</RpWrapper> : null;
    const otherComponents = [
      contactDetails.dateOfBirth ? moment(contactDetails.dateOfBirth).format('MM/DD/YYYY') : null,
      getPhoneNumber(contactDetails)
    ];
    const componentsWithSeparator = otherComponents
      .filter((component) => component !== null)
      .reduce(
        (acc: any, component, index, array) =>
          index < array.length - 1 ? [...acc, component, <DotSeparator />] : [...acc, component],
        []
      );

    return [rpComponent, ...componentsWithSeparator];
  }, [contactDetails]);

  return (
    <>
      {contactDetails && (
        <PatientInfoWrapper>
          <PatientInfo>
            <PatientName>
              {`${getContactName()}${contactDetails.dateOfBirth ? `, ${moment().diff(contactDetails.dateOfBirth, 'years', false)}` : ''
                }`}
            </PatientName>
            <PatientDetails>{getPatientDetails()}</PatientDetails>
          </PatientInfo>
          <div>
            <PatientActions contact={contactDetails} locationId={locationId} hideMessengerButton />
          </div>
        </PatientInfoWrapper>
      )}
    </>
  );
};
